<template>
  <div class="info-item info-block info-item-body feed-user">
    <div
      class="user-card"
      :class="{
        online: feedUser.online,
      }"
    >
      <router-link :to="'/profile/' + feedUser.id" class="user-card-wrapper">
        <div
          class="user-card-inner"
          :class="{ 'no-avatar': !feedUser.avatar }"
          :style="{
            'background-image': feedUser.avatar
              ? 'url(' + feedUser.avatar + ')'
              : '',
          }"
        >
          <div :to="'/profile/' + feedUser.id" class="user-card-name">
            <span class="first-name">{{ feedUser.first_name }}</span>
            <span>{{ feedUser.last_name }}</span>
          </div>
          <div class="user-card-info">
            <span v-if="feedUser.birthday && feedUser.birthday.length == 10">
              {{ age(feedUser.birthday) }}
              {{ declineNouns(age(feedUser.birthday),
              [
                this.$t("photos.year"),
                this.$t("photos.ofTheYear"),
                this.$t("photos.years")
                ]
              ) }}
            </span>
          </div>
        </div>
      </router-link>
    </div>
    <div class="feed-user-title">
      {{ $t("feed.doYouKnowEachOther") }}
    </div>
    <div class="feed-user-buttons">
      <button
        v-if="feedUser.is_friend.type == 0"
        @click="addToFriends"
        type="button"
        class="button"
        :class="{ 'button-loader': friendsLoader }"
      >
        {{ $t("feed.befriend") }}
      </button>
      <button
        v-if="feedUser.is_friend.type == 1"
        @click="cancelAddFriends"
        type="button"
        class="button"
        :class="{ 'button-loader': friendsLoader }"
      >
        {{ $t("feed.cancelRequest") }}
      </button>
      <button
        v-if="feedUser.is_friend.type == 2"
        type="button"
        class="button"
        disabled="true"
      >
        {{ $t("feed.requestAccepted") }}
      </button>
      <button
        v-if="feedUser.is_friend.type == 3"
        @click="acceptFriend"
        type="button"
        class="button"
        :class="{ 'button-loader': friendsLoader }"
      >
        {{ $t("feed.confirmFriendship") }}
      </button>
      <button @click="sendMessage" type="button" class="button-secondary">
        {{ $t("feed.writeMessage") }}
      </button>
      <button
        @click="$modal.show('gifts-list', { id: feedUser.id })"
        type="button"
        class="button-secondary"
      >
        {{ $t("feed.makeGift") }}
      </button>
    </div>
  </div>
</template>

<script>
import { declineNouns } from "@/mixins/declineNouns";

export default {
  name: "FeedUser",
  props: {
    i18n: Object,
  },
  mixins: [declineNouns],
  props: {
    feedUser: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      friendsLoader: false,
    };
  },
  methods: {
    addToFriends() {
      this.friendsLoader = true;
      this.$store
        .dispatch("profile/addToFriends", this.feedUser.id)
        .then(() => {
          this.friendsLoader = false;
          this.$modal.show("dialog", {
            title: this.$t("feed.success"),
            text: this.$t("feed.friendRequestSent"),
            buttons: [
              {
                title: this.$t("roulette.ok"),
              },
            ],
          });
          // Обновляем тип отношения для реактивности
          if (!this.feedUser.is_friend) {
            this.$set(this.feedUser, "is_friend", { type: 1 });
          } else {
            this.$set(this.feedUser.is_friend, "type", 1);
          }
        })
        .catch(() => {
          this.friendsLoader = false;
        });
    },
    cancelAddFriends() {
      this.friendsLoader = true;
      this.$store
        .dispatch("friendsOutgoing/cancelAddFriends", this.feedUser.id)
        .then(() => {
          this.friendsLoader = false;
          this.$modal.show("dialog", {
            title: this.$t("feed.success"),
            text: this.$t("feed.applicationCancelled"),
            buttons: [
              {
                title: this.$t("roulette.ok"),
              },
            ],
          });
          // Обновляем тип отношения для реактивности
          if (!this.feedUser.is_friend) {
            this.$set(this.feedUser, "is_friend", { type: 0 });
          } else {
            this.$set(this.feedUser.is_friend, "type", 0);
          }
        })
        .catch(() => {
          this.friendsLoader = false;
        });
    },
    acceptFriend() {
      this.friendsLoader = true;
      this.$store
        .dispatch("friendsIncoming/accept", this.feedUser.id)
        .then(() => {
          this.friendsLoader = false;
          this.$modal.show("dialog", {
            title: this.$t("feed.success"),
            text: this.$t("feed.offerFriendshipAccepted"),
            buttons: [
              {
                title: this.$t("roulette.ok"),
              },
            ],
          });
          // Обновляем тип отношения для реактивности
          if (!this.feedUser.is_friend) {
            this.$set(this.feedUser, "is_friend", { type: 2 });
          } else {
            this.$set(this.feedUser.is_friend, "type", 2);
          }
        })
        .catch(() => {
          this.friendsLoader = false;
        });
    },
    sendMessage() {
      this.$router.push({ name: "threads", params: { id: this.feedUser.id } });
    },
    // TODO: mixin, Search.vue, Profile.vue
    age(birthday) {
      let bDateArr = birthday.split(".");
      let bDate = new Date();
      bDate.setDate(bDateArr[0]);
      bDate.setMonth(bDateArr[1] - 1);
      bDate.setFullYear(bDateArr[2]);
      bDate = bDate.getTime();
      let years = new Date(+new Date() - bDate).getFullYear() - 1970;
      return years;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/components/_user-card";
</style>
